import { EventTriggerType, Trigger } from '../../domain';
import { TriggerExternalLinkDetail } from './components/TriggerExternalLinkDetail';
import { TriggerType } from './components/TriggerType';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

const getDuneQueryPath = (queryId?: number) => `https://dune.com/queries/${queryId}`;

export default function DuneQueryTriggerDetails({ trigger, triggerType }: Props) {
  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />

      <TriggerExternalLinkDetail
        label="Query ID"
        value={trigger.context?.duneQueryId || 'N/A'}
        href={getDuneQueryPath(trigger.context?.duneQueryId)}
      />
    </div>
  );
}
